import React, { Component } from "react";
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as tgCdes from "../consts/widetcodes";
import * as wActs from "../actions/website-actions";

class SubHeader extends Component {

  constructor(props) {
    super(props);
    this.state = {

    };
  }

  changeChannel(e,sel) {
    this.props.history.push(tgCdes.Channels[e.target.selectedIndex].url);
  }

  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }


  render() {

    return (
      <React.Fragment>
        <div className="search-row">
          <select className="select" onChange={(e) => { this.changeChannel(e,null)}}>
            {tgCdes.Channels.map((v,i) => {
              let isSel = !wActs.isNullOrEmpty(this.props.WebPage.Page.Settings.Channel) && this.props.WebPage.Page.Settings.Channel.toLowerCase().startsWith(v.value.toLowerCase());
              return <option key={"option-"+i} selected={isSel} value={v.value}>{this.getTranslation(v.tKey)}</option>
            })}
          </select>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    ServerParams: state.Website.ServerParams
  };
}

export default withRouter(connect(mapStateToProps)(SubHeader));
